import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import App from './App.vue';
import router from './router';
import config from './config';
import Rollbar from '@/plugins/rollbar';
import BingUETQ from '@/plugins/uetq';
import FacebookPixel from '@/plugins/facebookPixel';
import i18n from '@/lang';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import screenSize from './plugins/screen-plugin/plugin';
import useDomain from '@/composables/domainDependable';
import {registerLayoutComponent} from '@/layouts/global-component';
import {registerUiComponent} from '@/ui/global-component';


import '@/assets/sass/_main.scss';
import {loadDirectives} from '@/directives/directives';
import {createPinia} from 'pinia';

const { gtmId } = useDomain();

declare module 'vue' {
    interface ComponentCustomProperties {
        $config: Record<string, unknown>;
    }
}

// declare bing ads UET tags
declare global {
    interface Window {
        uetq: any;
    }
}

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia)

app
    .use(
        createGtm({
            id: gtmId,
            enabled: true,
            loadScript: true,
            vueRouter: router
        }),
    )
    .use(router)
    .use(BingUETQ)
    .use(FacebookPixel)
    .use(i18n)
    .use(screenSize, {
        tabletWidth: 800
    })
    .use(Rollbar)
;

registerLayoutComponent(app);
registerUiComponent(app)
loadDirectives(app);

app.config.globalProperties.$config = config;

app.mount('#app');
